export const getColorIcon = (color?: string) => {
  return color ? `text-${color}` : 'text-secondary'
}
